require('./bootstrap');

import ReactLoader from "react-loader";
import Form from "./components/application/Form";
import CheckApplication from "./components/CheckApplication";
import Documents from "./components/documents";
import BecomeAgentForm from "./components/BecomeAgentForm";

const react = new ReactLoader('#app');
react.component('application-form', Form);
react.component('check-application', CheckApplication);
react.component('documents', Documents);
react.component('become-agent', BecomeAgentForm);
react.render();
